import moment from 'moment';

export const validateExpCardDate = (value: string) => {
  if (value === '') return 'Completa este dato.';
  if (!moment(value, 'MM/YY').isValid()) return 'Fecha inválida';
  if (!moment(value, 'MM/YY').isAfter(moment())) return 'Tarjeta vencida';
};
